import { render, staticRenderFns } from "./Pins4Board.vue?vue&type=template&id=dba3036c&scoped=true&"
import script from "./Pins4Board.vue?vue&type=script&lang=js&"
export * from "./Pins4Board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba3036c",
  null
  
)

export default component.exports